import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { LoginFormData } from '@/hooks/forms/useLoginForm'
import { UseFormReturn } from 'react-hook-form'

interface AuthFormProps {
  form: UseFormReturn<LoginFormData>
  onSubmit: (e?: React.BaseSyntheticEvent) => void
}

export const AuthForm = ({ form, onSubmit }: AuthFormProps) => {
  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle>{'Logga in'}</CardTitle>
        <CardDescription>{'Logga in för att komma åt systemet'}</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-post</Label>
            <Input id="email" type="email" {...form.register('email')} placeholder="din@email.com" />
            {form.formState.errors.email && (
              <p className="text-sm text-destructive">{form.formState.errors.email.message}</p>
            )}
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Lösenord</Label>
            <Input id="password" type="password" {...form.register('password')} placeholder="••••••••" />
            {form.formState.errors.password && (
              <p className="text-sm text-destructive">{form.formState.errors.password.message}</p>
            )}
          </div>

          <Button type="submit" className="w-full">
            {'Logga in'}
          </Button>
        </form>
      </CardContent>
    </Card>
  )
}
